import React from "react";
import { connect } from "react-redux";
import { Tooltip } from "antd";
import PropTypes from "prop-types";
import history from "../history/history";
import { selectHeader } from "../actions/globalActions";
import { recordError } from "../utils/commonUtil";

function LinkTooltipContainer(props) {
  const goToRoute = (pathTo) => {
    try {
      if (props.headerChange) {
        props.selectHeader(props.headerChange);
      }
      history.push(pathTo);
    } catch (error) {
      recordError(error);
    }
  };
  return props.link ? (
    <div onClick={() => goToRoute(props.to)} id="anrLinkTooltip" data-test="linkToolTip-TestId">{props.data}</div>
  ) : (
    <Tooltip placement="bottom" title={props.title}>
      <a href={props.href} target="_blank" id="anrLinkTooltip">
        {props.data}
      </a>
    </Tooltip>
  );
}

LinkTooltipContainer.propTypes = {
  data: PropTypes.string,
  headerChange: PropTypes.string,
  href: PropTypes.string,
  link: PropTypes.bool,
  selectHeader: PropTypes.func,
  title: PropTypes.string,
  to: PropTypes.any
}

export const mapDispatchToProps = (dispatch) => {
  return {
    selectHeader: (data) => dispatch(selectHeader(data)),
  };
};
export default connect(null, mapDispatchToProps, null)(LinkTooltipContainer);
